import { Field } from 'react-final-form'

import FormItem from 'common/components/formItem'
import Textarea from 'common/components/textarea/Textarea'

const MAX_NAME_LENGTH = 250

const ruleInstructionValidation = (value: string) => {
  if (!value) {
    return 'Rule is required'
  } else if (value.length > MAX_NAME_LENGTH) {
    return `Rule must be ${MAX_NAME_LENGTH} characters or less`
  }

  return undefined
}

const RuleInstructionField = () => {
  return (
    <Field<string>
      name="rule"
      validate={ruleInstructionValidation}
      render={({ input, meta }) => (
        <FormItem
          label="Rule instruction"
          htmlFor="rule"
          error={meta.touched ? meta.error : undefined}
        >
          <Textarea
            id="rule"
            name={input.name}
            placeholder="Define your rule –  e.g Do not mention a Sale unless it's mentioned in the brief"
            className="h-25"
            value={input.value}
            onChange={input.onChange}
            onBlur={input.onBlur}
            showCharacterCount
            maxLength={MAX_NAME_LENGTH}
          />
        </FormItem>
      )}
    />
  )
}

export default RuleInstructionField
